export default __webpack_public_path__ + "static/media/PEGI_18.cc3c52e1.svg";